import type {EagGridStore} from '../store/createEagGridStore';
import {selectCanCopyColumn} from '../store/selectors/selectCanCopyColumn';
import type {EagColumn} from '../types/EagColumn';
import {copyRowsToClipboard} from './copyRowsToClipboard';

/** Copies current-page values only, independently of row or cell-range selection. */
export async function copyColumnToClipboard(store: EagGridStore, column: EagColumn): Promise<void> {
  const state = store.getState();
  if (!selectCanCopyColumn(state, column.key)) {
    return;
  }

  await copyRowsToClipboard(state.rows, [column], 'DATA');
}
